import { Requirements } from 'app/routes';

import { Account, setAccountsAccounts } from 'store/models/accounts';

export const AccountsControlRequirements: Requirements<{ accounts: Account[] }> = {
    methods: () => ({ accounts: { url: '/api/v1/account/accounts_info', cacheable: false } }),
    resolve: ({ result: { accounts } }) => [setAccountsAccounts(accounts)],
};
